var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("div", [
    _c("div", { staticClass: "login-logo-wrap" }, [
      _vm.shopLogo
        ? _c("img", {
            staticClass: "login-logo",
            attrs: { src: _vm.shopLogo, alt: _vm.appName },
          })
        : _c("img", {
            staticClass: "login-logo",
            attrs: { src: "/assets/img/header/header-logo.svg", alt: "프리원" },
          }),
    ]),
    _vm._v(" "),
    _c(
      "div",
      [
        _c(
          "v-form",
          {
            ref: "loginForm",
            staticClass: "form-style",
            attrs: { "lazy-validation": "" },
            on: {
              submit: function ($event) {
                $event.preventDefault()
                return _vm.login()
              },
            },
          },
          [
            _c("div", { staticClass: "mb-3" }, [
              _c("input", {
                directives: [
                  {
                    name: "model",
                    rawName: "v-model",
                    value: _vm.form.email,
                    expression: "form.email",
                  },
                ],
                staticClass: "input-form",
                attrs: {
                  type: "text",
                  placeholder: "이메일을 입력해주세요",
                  required: "",
                },
                domProps: { value: _vm.form.email },
                on: {
                  input: function ($event) {
                    if ($event.target.composing) return
                    _vm.$set(_vm.form, "email", $event.target.value)
                  },
                },
              }),
            ]),
            _vm._v(" "),
            _c("div", { staticClass: "mb-3" }, [
              _c("div", { staticClass: "password-wrap" }, [
                (_vm.passwordShow ? "text" : "password") === "checkbox"
                  ? _c("input", {
                      directives: [
                        {
                          name: "model",
                          rawName: "v-model",
                          value: _vm.form.password,
                          expression: "form.password",
                        },
                      ],
                      staticClass: "input-form",
                      attrs: {
                        placeholder: "* * * * * * * *",
                        autocomplete: "current-password",
                        required: "",
                        type: "checkbox",
                      },
                      domProps: {
                        checked: Array.isArray(_vm.form.password)
                          ? _vm._i(_vm.form.password, null) > -1
                          : _vm.form.password,
                      },
                      on: {
                        change: function ($event) {
                          var $$a = _vm.form.password,
                            $$el = $event.target,
                            $$c = $$el.checked ? true : false
                          if (Array.isArray($$a)) {
                            var $$v = null,
                              $$i = _vm._i($$a, $$v)
                            if ($$el.checked) {
                              $$i < 0 &&
                                _vm.$set(
                                  _vm.form,
                                  "password",
                                  $$a.concat([$$v])
                                )
                            } else {
                              $$i > -1 &&
                                _vm.$set(
                                  _vm.form,
                                  "password",
                                  $$a.slice(0, $$i).concat($$a.slice($$i + 1))
                                )
                            }
                          } else {
                            _vm.$set(_vm.form, "password", $$c)
                          }
                        },
                      },
                    })
                  : (_vm.passwordShow ? "text" : "password") === "radio"
                  ? _c("input", {
                      directives: [
                        {
                          name: "model",
                          rawName: "v-model",
                          value: _vm.form.password,
                          expression: "form.password",
                        },
                      ],
                      staticClass: "input-form",
                      attrs: {
                        placeholder: "* * * * * * * *",
                        autocomplete: "current-password",
                        required: "",
                        type: "radio",
                      },
                      domProps: { checked: _vm._q(_vm.form.password, null) },
                      on: {
                        change: function ($event) {
                          return _vm.$set(_vm.form, "password", null)
                        },
                      },
                    })
                  : _c("input", {
                      directives: [
                        {
                          name: "model",
                          rawName: "v-model",
                          value: _vm.form.password,
                          expression: "form.password",
                        },
                      ],
                      staticClass: "input-form",
                      attrs: {
                        placeholder: "* * * * * * * *",
                        autocomplete: "current-password",
                        required: "",
                        type: _vm.passwordShow ? "text" : "password",
                      },
                      domProps: { value: _vm.form.password },
                      on: {
                        input: function ($event) {
                          if ($event.target.composing) return
                          _vm.$set(_vm.form, "password", $event.target.value)
                        },
                      },
                    }),
                _vm._v(" "),
                _c(
                  "button",
                  {
                    staticClass: "password-toggle",
                    attrs: {
                      type: "button",
                      title: _vm.passwordShow
                        ? "비밀번호 감추기"
                        : "비밀번호 보기",
                      tabindex: "-1",
                    },
                    on: {
                      click: function ($event) {
                        _vm.passwordShow = !_vm.passwordShow
                      },
                    },
                  },
                  [
                    _c("i", {
                      class: _vm.passwordShow
                        ? "las la-eye"
                        : "las la-eye-slash",
                    }),
                  ]
                ),
              ]),
              _vm._v(" "),
              _c("p", { staticClass: "password-hint" }, [
                _vm._v("(8자 이상, 대소문자·숫자·특수문자 포함)"),
              ]),
            ]),
            _vm._v(" "),
            _c("div", { staticClass: "find-links" }, [
              _c("span", [_vm._v("아이디 찾기")]),
            ]),
            _vm._v(" "),
            _c(
              "button",
              {
                staticClass: "common-btn login-btn",
                style: _vm.loginAccentColor
                  ? { background: _vm.loginAccentColor, boxShadow: "none" }
                  : {},
                attrs: { type: "submit" },
                on: { click: _vm.login },
              },
              [_vm._v("로그인")]
            ),
            _vm._v(" "),
            _vm.loginQrCodeUrl
              ? _c("div", { staticClass: "qr-code-wrap" }, [
                  _c("img", {
                    staticClass: "qr-code-img",
                    attrs: {
                      src: _vm.loginQrCodeUrl,
                      alt: _vm.appName + " QR코드",
                    },
                  }),
                ])
              : _vm._e(),
            _vm._v(" "),
            _c(
              "router-link",
              {
                staticClass: "common-btn register-btn",
                attrs: {
                  to: _vm.shopSlug
                    ? {
                        name: "Registration",
                        query: { redirect: "/" + _vm.shopSlug },
                      }
                    : { name: "Registration" },
                },
              },
              [_vm._v("회원가입")]
            ),
          ],
          1
        ),
        _vm._v(" "),
        (_vm.themeType === "type_5" || _vm.themeType === "type_6") &&
        (_vm.generalSettings.social_login.naver == 1 ||
          _vm.generalSettings.social_login.kakao == 1)
          ? _c("div", { staticClass: "social-login-field" }, [
              _vm.generalSettings.social_login.naver == 1
                ? _c(
                    "button",
                    {
                      staticClass: "common-btn naver-login-btn",
                      on: { click: _vm.naverLogin },
                    },
                    [
                      _c("img", {
                        attrs: { src: "/assets/img/login/naver_icon.svg" },
                      }),
                      _vm._v(
                        "\n                네이버로 시작하기\n            "
                      ),
                    ]
                  )
                : _vm._e(),
              _vm._v(" "),
              _vm.generalSettings.social_login.kakao == 1
                ? _c(
                    "button",
                    {
                      staticClass: "common-btn kakao-login-btn",
                      on: { click: _vm.kakaoLogin },
                    },
                    [
                      _c("img", {
                        attrs: { src: "/assets/img/login/kakao_icon.svg" },
                      }),
                      _vm._v(
                        "\n                카카오로 시작하기\n            "
                      ),
                    ]
                  )
                : _vm._e(),
            ])
          : _vm._e(),
      ],
      1
    ),
    _vm._v(" "),
    false
      ? _c(
          "div",
          [
            _c(
              "v-row",
              { staticClass: "justify-center", attrs: { "no-gutters": "" } },
              [
                _vm.isLoginBanner
                  ? _c(
                      "v-col",
                      {
                        staticClass: "pa-10",
                        attrs: {
                          cols: "12",
                          lg: "6",
                          order: "2",
                          "order-lg": "1",
                        },
                      },
                      [
                        _c("banner", {
                          staticClass: "mt-5 mt-lg-0",
                          attrs: {
                            loading: false,
                            banner:
                              _vm.$store.getters["app/banners"].login_page,
                          },
                        }),
                      ],
                      1
                    )
                  : _vm._e(),
                _vm._v(" "),
                _c(
                  "v-col",
                  {
                    attrs: { cols: "12", order: "1", "order-lg": "2", lg: "6" },
                  },
                  [
                    _c(
                      "div",
                      { staticClass: "px-lg-7 text-center" },
                      [
                        _c(
                          "v-form",
                          {
                            ref: "loginForm",
                            attrs: { "lazy-validation": "" },
                            on: {
                              submit: function ($event) {
                                $event.preventDefault()
                                return _vm.login()
                              },
                            },
                          },
                          [
                            _vm.authSettings?.customer_login_with == "email" ||
                            (!_vm.showPhoneField &&
                              _vm.authSettings?.customer_login_with ==
                                "email_phone")
                              ? _c(
                                  "div",
                                  { staticClass: "mb-4 text-left" },
                                  [
                                    _c(
                                      "div",
                                      { staticClass: "mb-1 fs-13 fw-500" },
                                      [
                                        _vm._v(
                                          "\n                                " +
                                            _vm._s(_vm.$t("email")) +
                                            "\n                            "
                                        ),
                                      ]
                                    ),
                                    _vm._v(" "),
                                    _c("v-text-field", {
                                      attrs: {
                                        placeholder: _vm.$t("email_address"),
                                        type: "text",
                                        "error-messages": _vm.emailErrors,
                                        "hide-details": "auto",
                                        required: "",
                                        outlined: "",
                                      },
                                      model: {
                                        value: _vm.form.email,
                                        callback: function ($$v) {
                                          _vm.$set(_vm.form, "email", $$v)
                                        },
                                        expression: "form.email",
                                      },
                                    }),
                                    _vm._v(" "),
                                    _vm.authSettings?.customer_login_with ==
                                    "email_phone"
                                      ? _c(
                                          "div",
                                          {
                                            staticClass:
                                              "text-end font-italic fs-12 opacity-70",
                                          },
                                          [
                                            _c(
                                              "span",
                                              {
                                                staticClass:
                                                  "primary--text c-pointer",
                                                on: {
                                                  click: function ($event) {
                                                    _vm.showPhoneField =
                                                      !_vm.showPhoneField
                                                  },
                                                },
                                              },
                                              [
                                                _vm._v(
                                                  _vm._s(
                                                    _vm.$t("use_phone_instead")
                                                  )
                                                ),
                                              ]
                                            ),
                                          ]
                                        )
                                      : _vm._e(),
                                  ],
                                  1
                                )
                              : _vm._e(),
                            _vm._v(" "),
                            _vm.authSettings?.customer_login_with == "phone" ||
                            (_vm.showPhoneField &&
                              _vm.authSettings?.customer_login_with ==
                                "email_phone")
                              ? _c(
                                  "div",
                                  { staticClass: "mb-4 text-left" },
                                  [
                                    _c(
                                      "div",
                                      { staticClass: "mb-1 fs-13 fw-500" },
                                      [
                                        _vm._v(
                                          "\n                                " +
                                            _vm._s(_vm.$t("phone_number")) +
                                            "\n                            "
                                        ),
                                      ]
                                    ),
                                    _vm._v(" "),
                                    _c(
                                      "vue-tel-input",
                                      _vm._b(
                                        {
                                          attrs: {
                                            "only-countries":
                                              _vm.availableCountries,
                                          },
                                          on: { validate: _vm.phoneValidate },
                                          scopedSlots: _vm._u(
                                            [
                                              {
                                                key: "arrow-icon",
                                                fn: function () {
                                                  return [
                                                    _c(
                                                      "span",
                                                      {
                                                        staticClass:
                                                          "vti__dropdown-arrow",
                                                      },
                                                      [_vm._v(" ▼")]
                                                    ),
                                                  ]
                                                },
                                                proxy: true,
                                              },
                                            ],
                                            null,
                                            false,
                                            2578343687
                                          ),
                                          model: {
                                            value: _vm.form.phone,
                                            callback: function ($$v) {
                                              _vm.$set(_vm.form, "phone", $$v)
                                            },
                                            expression: "form.phone",
                                          },
                                        },
                                        "vue-tel-input",
                                        _vm.mobileInputProps,
                                        false
                                      )
                                    ),
                                    _vm._v(" "),
                                    _vm.$v.form.phone.$error
                                      ? _c(
                                          "div",
                                          {
                                            staticClass:
                                              "v-text-field__details mt-2 pl-3",
                                          },
                                          [
                                            _c(
                                              "div",
                                              {
                                                staticClass:
                                                  "v-messages theme--light error--text",
                                                attrs: { role: "alert" },
                                              },
                                              [
                                                _c(
                                                  "div",
                                                  {
                                                    staticClass:
                                                      "v-messages__wrapper",
                                                  },
                                                  [
                                                    _c(
                                                      "div",
                                                      {
                                                        staticClass:
                                                          "v-messages__message",
                                                      },
                                                      [
                                                        _vm._v(
                                                          _vm._s(
                                                            _vm.$t(
                                                              "this_field_is_required"
                                                            )
                                                          )
                                                        ),
                                                      ]
                                                    ),
                                                  ]
                                                ),
                                              ]
                                            ),
                                          ]
                                        )
                                      : _vm._e(),
                                    _vm._v(" "),
                                    !_vm.$v.form.phone.$error &&
                                    _vm.form.showInvalidPhone
                                      ? _c(
                                          "div",
                                          {
                                            staticClass:
                                              "v-text-field__details mt-2 pl-3",
                                          },
                                          [
                                            _c(
                                              "div",
                                              {
                                                staticClass:
                                                  "v-messages theme--light error--text",
                                                attrs: { role: "alert" },
                                              },
                                              [
                                                _c(
                                                  "div",
                                                  {
                                                    staticClass:
                                                      "v-messages__wrapper",
                                                  },
                                                  [
                                                    _c(
                                                      "div",
                                                      {
                                                        staticClass:
                                                          "v-messages__message",
                                                      },
                                                      [
                                                        _vm._v(
                                                          "\n                                            " +
                                                            _vm._s(
                                                              _vm.$t(
                                                                "phone_number_must_be_valid"
                                                              )
                                                            ) +
                                                            "\n                                        "
                                                        ),
                                                      ]
                                                    ),
                                                  ]
                                                ),
                                              ]
                                            ),
                                          ]
                                        )
                                      : _vm._e(),
                                    _vm._v(" "),
                                    _vm.authSettings?.customer_login_with ==
                                    "email_phone"
                                      ? _c(
                                          "div",
                                          {
                                            staticClass:
                                              "text-end font-italic fs-12 opacity-70",
                                          },
                                          [
                                            _c(
                                              "span",
                                              {
                                                staticClass:
                                                  "primary--text c-pointer",
                                                on: {
                                                  click: function ($event) {
                                                    _vm.showPhoneField =
                                                      !_vm.showPhoneField
                                                  },
                                                },
                                              },
                                              [
                                                _vm._v(
                                                  _vm._s(
                                                    _vm.$t("use_phone_instead")
                                                  )
                                                ),
                                              ]
                                            ),
                                          ]
                                        )
                                      : _vm._e(),
                                  ],
                                  1
                                )
                              : _vm._e(),
                            _vm._v(" "),
                            _c(
                              "div",
                              [
                                _c(
                                  "div",
                                  {
                                    staticClass: "mb-1 fs-13 fw-500 text-left",
                                  },
                                  [
                                    _vm._v(
                                      "\n                                " +
                                        _vm._s(_vm.$t("password")) +
                                        "\n                            "
                                    ),
                                  ]
                                ),
                                _vm._v(" "),
                                _c("v-text-field", {
                                  staticClass: "input-group--focused",
                                  attrs: {
                                    placeholder: "* * * * * * * *",
                                    "error-messages": _vm.passwordErrors,
                                    type: _vm.passwordShow
                                      ? "text"
                                      : "password",
                                    "append-icon": _vm.passwordShow
                                      ? "las la-eye"
                                      : "las la-eye-slash",
                                    autocomplete: "current-password",
                                    "hide-details": "auto",
                                    required: "",
                                    outlined: "",
                                  },
                                  on: {
                                    "click:append": function ($event) {
                                      _vm.passwordShow = !_vm.passwordShow
                                    },
                                  },
                                  model: {
                                    value: _vm.form.password,
                                    callback: function ($$v) {
                                      _vm.$set(_vm.form, "password", $$v)
                                    },
                                    expression: "form.password",
                                  },
                                }),
                                _vm._v(" "),
                                _c(
                                  "div",
                                  {
                                    staticClass:
                                      "text-end font-italic fs-12 opacity-70",
                                  },
                                  [
                                    _c(
                                      "router-link",
                                      {
                                        staticClass: "primary--text",
                                        attrs: {
                                          to: { name: "ForgotPassword" },
                                        },
                                      },
                                      [
                                        _vm._v(
                                          _vm._s(_vm.$t("forgot_password")) +
                                            "?"
                                        ),
                                      ]
                                    ),
                                  ],
                                  1
                                ),
                              ],
                              1
                            ),
                            _vm._v(" "),
                            _c(
                              "v-btn",
                              {
                                staticClass: "px-16 mb-4",
                                attrs: {
                                  "x-large": "",
                                  elevation: "0",
                                  type: "submit",
                                  color: "primary",
                                  loading: _vm.loading,
                                  disabled: _vm.loading,
                                },
                                on: { click: _vm.login },
                              },
                              [_vm._v(_vm._s(_vm.$t("login")))]
                            ),
                          ],
                          1
                        ),
                        _vm._v(" "),
                        _vm.generalSettings.social_login.facebook == 1 ||
                        _vm.generalSettings.social_login.twitter == 1 ||
                        _vm.generalSettings.social_login.google == 1
                          ? _c(
                              "div",
                              [
                                _c(
                                  "div",
                                  { staticClass: "d-flex align-center mb-3" },
                                  [
                                    _c(
                                      "span",
                                      {
                                        staticClass:
                                          "me-2 fs-13 fw-500 opacity-60",
                                      },
                                      [
                                        _vm._v(
                                          _vm._s(_vm.$t("or")) +
                                            ", " +
                                            _vm._s(_vm.$t("login_with"))
                                        ),
                                      ]
                                    ),
                                    _vm._v(" "),
                                    _c("v-divider"),
                                  ],
                                  1
                                ),
                                _vm._v(" "),
                                _c("SocialLogin", { staticClass: "mb-5" }),
                              ],
                              1
                            )
                          : _vm._e(),
                        _vm._v(" "),
                        _vm.generalSettings.social_login.naver == 1 ||
                        _vm.generalSettings.social_login.kakao == 1
                          ? _c("div", { staticClass: "border-top py-2" }, [
                              _c(
                                "div",
                                {
                                  staticClass:
                                    "d-flex align-center justify-center mt-3 mb-3",
                                },
                                [
                                  _vm.generalSettings.social_login.naver == 1
                                    ? _c("img", {
                                        staticStyle: { cursor: "pointer" },
                                        attrs: {
                                          src: _vm.static_asset(
                                            "/assets/img/icons/naver_login.png"
                                          ),
                                          height: "50",
                                        },
                                        on: { click: _vm.naverLogin },
                                      })
                                    : _vm._e(),
                                  _vm._v(" "),
                                  _vm.generalSettings.social_login.kakao == 1
                                    ? _c("img", {
                                        staticStyle: {
                                          "margin-left": "5px",
                                          cursor: "pointer",
                                        },
                                        attrs: {
                                          src: _vm.static_asset(
                                            "/assets/img/icons/kakao_login.png"
                                          ),
                                          height: "50",
                                        },
                                        on: { click: _vm.kakaoLogin },
                                      })
                                    : _vm._e(),
                                ]
                              ),
                            ])
                          : _vm._e(),
                        _vm._v(" "),
                        _c(
                          "div",
                          [
                            _vm._v(
                              "\n                        " +
                                _vm._s(_vm.$t("dont_have_an_account")) +
                                ",\n                        "
                            ),
                            _c(
                              "router-link",
                              {
                                staticClass:
                                  "primary--text text-decoration-underline",
                                attrs: { to: { name: "Registration" } },
                              },
                              [_vm._v(_vm._s(_vm.$t("signup")))]
                            ),
                          ],
                          1
                        ),
                      ],
                      1
                    ),
                  ]
                ),
              ],
              1
            ),
          ],
          1
        )
      : _vm._e(),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }